import { Link, useLocation } from "react-router-dom";
import { cn } from "@/src/lib/utils";

export const NavLink = ({ icon, href, target, children }) => {
  const location = useLocation();
  const isExternal = target === "_blank";
  const isActive = !isExternal && (location.pathname === href || location.pathname === href.toLowerCase());

  const className = cn(
    "flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 group relative",
    isActive
      ? "bg-primary/10 text-primary border-l-[3px] border-primary pl-[9px]"
      : "text-muted-foreground hover:text-foreground hover:bg-secondary/80"
  );

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={className}>
        <span className="flex-shrink-0">{icon}</span>
        <span>{children}</span>
      </a>
    );
  }

  return (
    <Link to={href} className={className}>
      <span className="flex-shrink-0">{icon}</span>
      <span>{children}</span>
    </Link>
  );
};
